module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "congrats",
    class: {
      'mobile': _vm.$mobile
    }
  }, [_c('div', {
    staticClass: "half"
  }, [_c('div', {
    staticClass: "points-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "video-container"
  }, [(_vm.endtexts[_vm.text].video) ? _c('video', {
    attrs: {
      "id": "video",
      "src": _vm.endtexts[_vm.text].video,
      "autoplay": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "points count"
  }, [_c('span', [_vm._v(_vm._s(_vm.points))])])])]), _vm._v(" "), _c('div', {
    staticClass: "half"
  }, [_c('div', {
    staticClass: "text-container"
  }, [_c('div', {
    staticClass: "title-01 congrats-title",
    domProps: {
      "innerHTML": _vm._s(_vm.endtexts[_vm.text].header)
    }
  }, [_vm._v("\n                Gefeliciteerd!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "title-02 congrats-sub-title"
  }, [_vm._v("\n                Je hebt " + _vm._s(_vm.points) + " punten gehaald.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "copy-02 congrats-points-title"
  }, [_vm._v("\n                Je had " + _vm._s(_vm.maxscore) + " punten kunnen halen.\n            ")])]), _vm._v(" "), (_vm.$mobile) ? _c('a', {
    staticClass: "button mobile",
    on: {
      "click": function($event) {
        _vm.mobileendtext = true
      }
    }
  }, [_vm._v(" OK")]) : _vm._e()]), _vm._v(" "), (!_vm.$mobile) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "copy-01",
    domProps: {
      "innerHTML": _vm._s(_vm.endtexts[_vm.text].text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.restart($event)
      }
    }
  }, [_vm._v("Speel opnieuw")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://www.om.nl",
      "target": "_BLANK"
    }
  }, [_vm._v("Meer informatie")])])]) : _vm._e(), _vm._v(" "), (_vm.$mobile && _vm.mobileendtext) ? _c('div', {
    staticClass: "mobile-endtext"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "copy-01",
    domProps: {
      "innerHTML": _vm._s(_vm.endtexts[_vm.text].text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('a', {
    staticClass: "button mobile",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.restart($event)
      }
    }
  }, [_vm._v("Speel opnieuw")]), _vm._v(" "), _c('a', {
    staticClass: "button mobile",
    attrs: {
      "href": "https://www.om.nl",
      "target": "_BLANK"
    }
  }, [_vm._v("Meer informatie")])])])]) : _vm._e(), _vm._v(" "), (!_vm.$mobile || _vm.mobileendtext) ? _c('span', {
    staticClass: "disclaimer-button",
    on: {
      "click": function($event) {
        _vm.disclaimer = true
      }
    }
  }, [_vm._v("\n        Credits\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disclaimer),
      expression: "disclaimer"
    }],
    staticClass: "disclaimer"
  }, [_c('div', {
    staticClass: "intro-text-container"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.disclaimer = false
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-text-box"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Credits")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Ontwerp en realisatie:")]), _c('br'), _vm._v("\n                Openbaar Ministerie in samenwerking met Ijsfontein.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Met dank aan:")]), _c('br'), _vm._v("\n                Officier van justitie Gabriëlle Hoppenbrouwers, Landelijk Team Forensische Opsporing van de Politie, Rechtbank Amsterdam. Beelden: Rechtbank Amsterdam, AVRO/TROS Opsporing Verzocht, Pieter Baan Centrum, Nederlands Forensisch Instituut, Politie en Openbaar Ministerie.\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c2c98578!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Congrats.vue
// module id = 125
// module chunks = 1